import { Component, OnInit } from "@angular/core";
import { OidcSecurityService } from "angular-auth-oidc-client";

@Component({
  selector: "app-admin-navbar",
  templateUrl: "./admin-navbar.component.html",
})
export class AdminNavbarComponent implements OnInit {

  userInfo: any;

  constructor(private oidcSecurityService: OidcSecurityService){}

  ngOnInit(): void {
    this.getUserData();
  }

  getUserData() {
    this.oidcSecurityService.checkAuth().subscribe((data: any) => {
      this.userInfo = data.userData;
    })
  }
}
